
// Getters (GET*)
export const GET_USER_LIST = 'GET_USER_LIST';
export const GET_REGISTER_USER_FORM_VISIBILITY = 'GET_REGISTER_USER_FORM_VISIBILITY';
export const GET_SELECTED_USER = 'GET_SELECTED_USER';
export const GET_USER_USERTYPE_LIST = 'GET_USER_USERTYPE_LIST';
export const GET_CURRENT_USER_TAB = 'GET_CURRENT_USER_TAB';
export const GET_USER_PROFILE_FUNCTIONALITIES_GROUPED = 'GET_USER_PROFILE_FUNCTIONALITIES_GROUPED';
export const GET_USER_FUNCTIONALITY_RESTRICTIONS = 'GET_USER_FUNCTIONALITY_RESTRICTIONS';
export const GET_CLIENT_CONTRACTS = 'GET_CLIENT_CONTRACTS';
export const GET_USER_BONDS = 'GET_USER_BONDS';
export const GET_SELECTED_BOND = 'GET_SELECTED_BOND';
export const GET_LOCALE_TYPES = 'GET_LOCALE_TYPES';
export const GET_ROLE_CLASSIFICATIONS = 'GET_ROLE_CLASSIFICATIONS';



// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
export const FETCH_USER_LIST = 'FETCH_USER_LIST';
export const CREATE_USER_LIST = 'CREATE_USER_LIST';
export const UPDATE_REGISTER_USER_FORM_VISIBILITY = 'UPDATE_REGISTER_USER_FORM_VISIBILITY';
export const UPDATE_SELECTED_USER = 'UPDATE_SELECTED_USER';
export const CREATE_NEW_USER = 'CREATE_NEW_USER';
export const UPDATE_USER_LIST = 'UPDATE_USER_LIST';
export const UPDATE_USER = 'UPDATE_USER';
export const FETCH_USER_TYPE_LIST = 'FETCH_USER_TYPE_LIST';
export const FETCH_USER_PROFILES = 'FETCH_USER_PROFILES';
export const UPDATE_SELECTED_USER_PROFILES = 'UPDATE_SELECTED_USER_PROFILES';
export const UPDATE_CURRENT_USER_TAB = 'UPDATE_CURRENT_USER_TAB';
export const FETCH_USER_PROFILE_FUNCTIONALITIES_GROUPED = 'FETCH_USER_PROFILE_FUNCTIONALITIES_GROUPED';
export const UPDATE_USER_PROFILE_FUNCTIONALITIES_GROUPED = 'UPDATE_USER_PROFILE_FUNCTIONALITIES_GROUPED';
export const UPDATE_USER_FUNCTIONALITY_RESTRICTIONS = 'UPDATE_USER_FUNCTIONALITY_RESTRICTIONS';
export const FETCH_USER_FUNCTIONALITY_RESTRICTIONS = 'FETCH_USER_FUNCTIONALITY_RESTRICTIONS';
export const FETCH_CLIENT_CONTRACTS = 'FETCH_CLIENT_CONTRACTS';
export const FETCH_USER_BONDS_LIST = 'FETCH_USER_BONDS_LIST';
export const UPDATE_USER_BONDS = 'UPDATE_USER_BONDS';
export const CREATE_BOND = 'CREATE_BOND';
export const UPDATE_BOND = 'UPDATE_BOND';
export const UPDATE_SELECTED_BOND = 'UPDATE_SELECTED_BOND';
export const UPDATE_BOND_LIST = 'UPDATE_BOND_LIST';
export const FETCH_LOCALE_TYPES_LIST = 'FETCH_LOCALE_TYPES_LIST';
export const FETCH_EMAIL_CONFIRMATION = 'FETCH_EMAIL_CONFIRMATION';
export const UPDATE_EMAIL_CONFIRMATION = 'UPDATE_EMAIL_CONFIRMATION';
export const DELETE_USER_BONDS = 'DELETE_USER_BONDS';
export const FETCH_USER_REPORT = 'FETCH_USER_REPORT';
export const FETCH_ROLE_CLASSIFICATIONS = 'FETCH_ROLE_CLASSIFICATIONS';


// Mutations (SET*, ADD*, REMOVE*)
export const SET_USER_LIST = 'SET_USER_LIST';
export const SET_REGISTER_USER_FORM_VISIBILITY = 'SET_REGISTER_USER_FORM_VISIBILITY';
export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const ADD_USER_TO_LIST = 'ADD_USER_TO_LIST';
export const SET_PROFILE_LIST = 'SET_PROFILE_LIST';
export const SET_USER_TYPE_LIST = 'SET_USER_TYPE_LIST';
export const SET_USER_PROFILES = 'SET_USER_PROFILES';
export const SET_CURRENT_USER_TAB = 'SET_CURRENT_USER_TAB';
export const SET_USER_FUNCTIONALITY_RESTRICTIONS = 'SET_USER_FUNCTIONALITY_RESTRICTIONS';
export const SET_USER_PROFILE_FUNCTIONALITIES_GROUPED = 'SET_USER_PROFILE_FUNCTIONALITIES_GROUPED';
export const SET_CLIENT_CONTRACTS = 'SET_CLIENT_CONTRACTS';
export const SET_USER_BONDS_LIST = 'SET_USER_BONDS_LIST';
export const SET_SELECTED_BOND = 'SET_SELECTED_BOND';
export const ADD_BOND_TO_LIST = 'ADD_BOND_TO_LIST';
export const SET_LOCALE_TYPES_LIST = 'SET_LOCALE_TYPES_LIST';
export const SET_CONFIRMATION_EMAIL = 'SET_CONFIRMATION_EMAIL';
export const SET_ROLE_CLASSIFICATIONS = 'SET_ROLE_CLASSIFICATIONS';
